import React from 'react'
import { Box, Stack } from '@mui/material'

interface EditableTypographyProps {
  htmlContent: string
}

export const EditableTypography: React.FC<EditableTypographyProps> = ({
  htmlContent,
}) => {
  const normalizedContent = (htmlContent ?? '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\u00a0/g, ' ')

  return (
    <Stack p={1}>
      <Box
        sx={{
          wordBreak: 'normal',
          overflowWrap: 'break-word',
          '& p': { margin: 0 },
          '& .ql-size-small': { fontSize: '0.75em' },
          '& .ql-size-large': { fontSize: '1.5em' },
          '& .ql-size-huge': { fontSize: '2.5em' },
        }}
        dangerouslySetInnerHTML={{ __html: normalizedContent }}
      />
    </Stack>
  )
}
